import { useMutation as c } from "react-query";
import { useEnvironment as d } from "../../../common/hooks/environment/useEnvironment.js";
import { ScopeAdapter as u } from "../../models/scope/scope.adapter.js";
import { getAdapter as p } from "../../adapter.js";
class f extends Error {
  constructor(o, r, s) {
    super(r), this.errorCode = o, this.retryAfterSeconds = s;
  }
}
function _() {
  const { backendBaseUrl: i } = d();
  return c(async ({ token: o, phone: r, scope: s }) => {
    const a = p(u).serialize(s), t = await fetch(`${i}/verification/`, {
      method: "POST",
      body: JSON.stringify({ phone: r, scope: a }),
      headers: {
        authorization: `Token ${o}`
      }
    });
    if (!t.ok) {
      const e = await t.json().catch(() => ({}));
      throw new f(
        (e == null ? void 0 : e.error_code) ?? "unknown",
        (e == null ? void 0 : e.detail) ?? `Request failed with status ${t.status}`,
        e == null ? void 0 : e.retry_after_seconds
      );
    }
    const n = await t.json();
    return {
      otpRequestId: n.otp_request_id,
      expiresInSeconds: n.expires_in_seconds,
      cooldownSeconds: n.cooldown_seconds
    };
  });
}
export {
  f as PhoneVerificationRequestError,
  _ as usePhoneVerificationRequest
};
//# sourceMappingURL=usePhoneVerificationRequest.js.map
